import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

export const VariableHighlight = (getVariableIds: () => readonly string[]) => {
  return Extension.create({
    name: "variableHighlight",

    addProseMirrorPlugins() {
      return [
        new Plugin({
          key: new PluginKey("variableHighlight"),
          props: {
            decorations: (state) => {
              const { doc } = state;
              const decorations: Decoration[] = [];
              const placeholderValues = getVariableIds();
              doc.descendants((node, pos) => {
                if (node.isText && node.text) {
                  placeholderValues.forEach((id) => {
                    if (!node.text) return;
                    const escapedId = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    const regex = new RegExp(escapedId, "g");

                    let match;
                    while ((match = regex.exec(node.text)) !== null) {
                      const start = pos + match.index;
                      const end = start + match[0].length;
                      decorations.push(
                        Decoration.inline(start, end, {
                          class: "variable-highlight",
                        })
                      );
                    }
                  });
                }
              });

              return DecorationSet.create(doc, decorations);
            },
          },
        }),
      ];
    },
  });
};
